<p>Dashboard!</p>

<button class="btn btn-primary" (click)="logout()">Log Out</button>
